import { formatGrouped } from '@/_shared/lib/format';

export const PREVIEW_TIMED_OUT_TITLE = 'Preview took too long';

export function previewTimedOutMessage(timeoutMs: number): string {
  const seconds = Math.round(timeoutMs / 1000);
  return (
    `The warehouse didn't return a sample within ${formatGrouped(seconds)} seconds. ` +
    'It may be starting up or busy. Refresh to try again.'
  );
}

export const PREVIEW_EMPTY_COPY = 'No members matched this preview. Broaden the conditions and try again.';

export const NO_COLUMN_METADATA_COPY =
  "The warehouse didn't return column names for this query, so preview didn't load a sample.";

/** Matches the webapp data-graph audience preview title (`Previewing 25 of 1,397 Customers`). */
export function previewHeaderText(
  baseModelName: string,
  sampleSize: number,
  totalCount: number | null,
  rowLimit?: number,
): string {
  if (sampleSize === 0 || totalCount === 0) {
    return 'Preview';
  }
  const trimmed = baseModelName.trim();
  const modelLabel = trimmed.length > 0 ? ` ${trimmed}` : '';
  const sample = formatGrouped(sampleSize);
  if (totalCount == null) {
    return `Previewing ${sample}${modelLabel}`;
  }
  const truncated = rowLimit != null && sampleSize >= rowLimit;
  if (!truncated && sampleSize >= totalCount) {
    return `Showing all ${formatGrouped(totalCount)}${modelLabel}`;
  }
  return `Previewing ${sample} of ${formatGrouped(totalCount)}${modelLabel}`;
}
